import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  IconButton,
  Link,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Tooltip, Typography
} from '@mui/material';
import { PolicyRule } from '../../model/interfaces/policyRule';
import { Link as RouterLink } from 'react-router-dom';

interface RuleProps {
  rule: PolicyRule;
  onClick: (removedRule: PolicyRule) => void;
  order?: number;
}

const RemovableListing = (props: RuleProps) => {
  const { rule, onClick, order } = props;

  return (
    <Tooltip title={rule.description}>
      <ListItem
        component={Paper}
        variant="outlined"
        elevation={0}
        sx={{
          backgroundColor: '#fff',
          border: '1px solid #E3E2DE',
          paddingY: 1,
          paddingX: 1.25,
          gap: 1.25,
          borderRadius: '6px',
          '&:hover': { borderColor: '#3B82F6' }
        }}
      >
        {order !== undefined && (
          <Box
            sx={{
              width: 22,
              height: 22,
              flexShrink: 0,
              borderRadius: '50%',
              backgroundColor: '#F1F1EF',
              display: 'grid',
              placeItems: 'center',
              fontSize: 11,
              fontWeight: 700
            }}
          >
            {order}
          </Box>
        )}
        <ListItemText
          sx={{ margin: 0 }}
          secondaryTypographyProps={{
            sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
            noWrap: true
          }}
          primary={<Typography variant={'body2'}>
            <RouterLink to={`/rules/${rule.policyRuleId}`} style={{ textDecoration: 'none' }}>
              <Link underline='hover'>{rule.name}</Link>
            </RouterLink>
          </Typography>}
          secondary={<Typography variant={'caption'}> {rule.description} </Typography>}
        />
        <ListItemIcon sx={{ minWidth: 0 }}>
          <IconButton size="small" onClick={() => onClick(rule)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </ListItemIcon>
      </ListItem>
    </Tooltip>
  );
};

export default RemovableListing;
